import React from 'react';
import { Alert, Box } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

const ServerError = ({ error }) => (
  <Alert.error>
    <Box fontWeight="bold">
      {error || 'Something went wrong when sending your request'}
    </Box>
    {!error && <Box>Please try again</Box>}
  </Alert.error>
);

ServerError.propTypes = {
  error: PropTypes.string,
};

export default ServerError;
